import RouteWithAddedPropsAndPricesType from "@Route/types/RouteWithAddedPropsAndPrices.type";
import IntermodalRouteWithDetailsType from "@Intermodal/types/IntermodalRouteWithDetails.type";
import isSameRouteBasedOnTravelTimes from "@Route/functions/isSameRouteBasedOnTravelTimes";
import {nomagoCompanyId} from "@SearchResults/api/constants/companyIds";

type sortRoutesFunction = (
    a: RouteWithAddedPropsAndPricesType | IntermodalRouteWithDetailsType,
    b: RouteWithAddedPropsAndPricesType | IntermodalRouteWithDetailsType
) => number
export default function sortByIsNomago(): sortRoutesFunction {
    return function sort(a, b) {
        const areSameRoutesBasedOnTravelTime = isSameRouteBasedOnTravelTimes(a, b)
        if (!areSameRoutesBasedOnTravelTime) {
            return 0
        }
        const aIsNomago = a.companyId === nomagoCompanyId
        const bIsNomago = b.companyId === nomagoCompanyId

        if (aIsNomago && bIsNomago) {
            return 0
        }
        if (aIsNomago) {
            return 1
        }

        if (bIsNomago) {
            return -1
        }

        return 0
    }
}